"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComparatorContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const ComparatorTrigger_1 = require("./ComparatorTrigger");
const constants_1 = require("../../constants");
const Div_1 = require("../Div");
const Flex_1 = require("../Flex");
const Icon_1 = require("../Icon");
const Text_1 = require("../Text");
const ComparatorContainerBox = (0, styled_1.default)(Div_1.Div)(({ color = constants_1.Color.BLUE }) => ({
    display: 'inline-flex',
    background: constants_1.Color.WHITE,
    border: constants_1.theme.border.style.thin,
    borderRadius: constants_1.theme.border.radius.normal,
    boxShadow: constants_1.theme.boxShadow.normal,
    color,
    fontSize: 14,
    overflow: 'hidden',
    userSelect: 'none',
}));
const TitleElement = (0, styled_1.default)(Flex_1.Flex)(constants_1.comparatorStyles);
const ComparatorContainer = ({ children, color, icon, label, onClose, }) => {
    return ((0, jsx_runtime_1.jsxs)(ComparatorContainerBox, { color: color, children: [(0, jsx_runtime_1.jsxs)(TitleElement, { gap: 1, design: "bold", children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: icon, design: "solid" }), (0, jsx_runtime_1.jsx)(Text_1.Text, { bold: true, children: label })] }), children, onClose && ((0, jsx_runtime_1.jsx)(ComparatorTrigger_1.ComparatorTrigger, { onClick: onClose, design: "light", children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: "XIcon" }) }))] }));
};
exports.ComparatorContainer = ComparatorContainer;
